var _defs, _line, _line2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBackgroundImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".add-background-image-cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:28px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "add-background-image-cls-1",
    x1: 18.75,
    y1: 180.18,
    x2: 182.56,
    y2: 18.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "add-background-image-cls-1",
    x1: 40.5,
    y1: 295.65,
    x2: 318.5,
    y2: 18.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-background-image-cls-1",
    d: "m167.5,295.65l-122.25.03c-14.01,0-25.37-11.36-25.37-25.37V48.02c0-14.01,11.36-25.37,25.37-25.37h272.38c14.01,0,25.37,11.36,25.37,25.37l.5,92.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-background-image-cls-1",
    d: "m375.22,331.35h-145.37c-3.33,0-6.03-2.7-6.03-6.03v-120.56c0-3.33,2.7-6.03,5.03-6.03h145.37c4.33,0,7.03,2.7,7.03,6.03v120.56c0,3.33-2.7,6.03-6.03,6.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBackgroundImageIcon);
export default __webpack_public_path__ + "static/media/add_background_image-icon.deede60690945d3ab643de06a81a0015.svg";
export { ForwardRef as ReactComponent };